import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

@Component({
  selector: 'app-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './avatar.component.scss',
  templateUrl: './avatar.component.html',
})
export class AvatarComponent {
  name = input.required<string>();
  src = input<string>();

  private readonly failedSrc = signal<string | undefined>(undefined);

  protected readonly displayedSrc = computed(() => {
    const src = this.src();
    return src === this.failedSrc() ? undefined : src;
  });

  protected initials = computed(() => {
    const cleanName = this.name().trim();

    if (!cleanName) return 'A';

    const words = cleanName.split(/\s+/);

    if (words.length === 1) {
      return (words[0]?.[0] ?? 'A').toUpperCase();
    }

    const firstLetter = words[0]?.[0] ?? '';
    const secondLetter = words[1]?.[0] ?? '';

    return (firstLetter + secondLetter).toUpperCase();
  });

  protected onImageError(): void {
    this.failedSrc.set(this.src());
  }
}
